/**
* Left Right Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Left Right Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'left-right-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      const llslick = $( '.left-right-slider .slider' ).slick( {
        dots: false,
        arrows: false,
        slidesToShow: 1,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
      } );

      $( llslick ).on( 'afterChange', function( event, slick, currentSlide, nextSlide ) {
        if ( window.innerWidth < 1023 ) {
          $( 'html, body' ).animate( {
            scrollTop: $( '.scroll-change__anchor' ).offset().top - 132,
          }, 'slow' );
        }
      } );

      // prev slide
      $( document ).on( 'click', '.left-right-slider .custom-slider-nav .prev-slide', function() {
        $( this ).closest( '.slider' ).slick( 'slickPrev' );
      } );

      // next slide
      $( document ).on( 'click', '.left-right-slider .custom-slider-nav .next-slide', function() {
        $( this ).closest( '.slider' ).slick( 'slickNext' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'left-right-slider', COMPONENT );
} )( app );
